<template lang="html">

  <el-main>
    <div class="top-section">
      <el-row class="list-header">
        <el-col :span="24" class="section-header" :gutter="20">
          <div class="section-title">Tablero de Control</div>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="card-row row1">

        <el-col class="card-col" :xs="22" :sm="22" :md="22" :lg="8" :xl="8">
          <el-card shadow="hover" class="box-card" :body-style="{ padding: '0px'}"  >
            <div slot="header" class="clearfix" style="background-color:#001F5C;">
              <span class="card-title" >Herramientas</span>
            </div>

            <div class="text item">
              <el-button size="mini" class="text item" type="text" v-on:click="goToLink('/validacion')">Validación</el-button>
            </div>
            <div class="text item">
              <el-button class="text item" type="text" v-on:click="goToLink('/calculadora')">Calculadoras</el-button>
            </div>
            <div class="text item">
              <a :href="tools[2].url" target="_blank" :title="tools[2].url">{{tools[2].text}}</a>
            </div>
          </el-card>

        </el-col>
        <el-col class="card-col" :xs="22" :sm="22" :md="22" :lg="8" :xl="8">
          <el-card shadow="hover" class="box-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="clearfix" style="background-color:#001F5C;">
              <span class="card-title">Aperturas</span>
            </div>
            <div class="text item">
              <a :href="openings[0].url" target="_blank" :title="openings[0].url">{{openings[0].text}}</a>
            </div>
            <div class="text item">
              <a :href="openings[1].url" target="_blank" :title="openings[1].url">{{openings[1].text}}</a>
            </div>
            <div class="text item">
              <a :href="openings[2].url" target="_blank" :title="openings[2].url">{{openings[2].text}}</a>
            </div>
          </el-card>

        </el-col>
        <el-col class="card-col" :xs="22" :sm="22" :md="22" :lg="8" :xl="8">
          <el-card shadow="hover" class="box-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="clearfix" style="background-color:#001F5C;">
              <span class="card-title">Complemento</span>
            </div>
            <div class="text item">
              <a :href="complements[0].url" target="_blank" :title="complements[0].url">{{complements[0].text}}</a>
            </div>
            <div class="text item">
              <a :href="complements[1].url" target="_blank" :title="complements[1].url">{{complements[1].text}}</a>
            </div>
            <div class="text item">  &nbsp;</div>
          </el-card>


        </el-col>

      </el-row>

      <el-row :gutter="10" class="card-row row2">

        <el-col class="card-col" :xs="22" :sm="22" :md="22" :lg="8" :xl="8">
          <el-card shadow="hover" class="box-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="clearfix header" style="background-color:#001F5C;">
              <span class="card-title">Reportes</span>
            </div>
            <div class="text item">
              <a :href="reports[0].url" target="_blank" :title="reports[0].url">{{reports[0].text}}</a>
            </div>
            <div class="text item">
              <el-button class="text item" type="text" v-on:click="goToLink('/lista-de-analisis')">Análisis portafolios</el-button>
            </div>
            <div class="text item">&nbsp;</div>
          </el-card>

        </el-col>
        <el-col class="card-col" :xs="22" :sm="22" :md="22" :lg="8" :xl="8">
          <el-card shadow="hover" class="box-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="clearfix" style="background-color:#001F5C;">
              <span class="card-title">Operaciones</span>
            </div>
            <div class="text item">
              <a :href="operations[0].url" target="_blank" :title="operations[0].url">{{operations[0].text}}</a>
            </div>
            <div class="text item">
              <a :href="operations[1].url" target="_blank" :title="operations[1].url">{{operations[1].text}}</a>
            </div>
            <div class="text item">&nbsp;</div>
          </el-card>

        </el-col>
        <el-col class="card-col" :xs="22" :sm="22" :md="22" :lg="8" :xl="8">
          <el-card shadow="hover" class="box-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="clearfix" style="background-color:#001F5C;">
              <span class="card-title">Web</span>
            </div>
            <div class="text item">
              <a :href="web[0].url" target="_blank" :title="web[0].url">{{web[0].text}}</a>
            </div>
            <div class="text item">
              <a :href="web[1].url" target="_blank" :title="web[1].url">{{web[1].text}}</a>
            </div>
            <div class="text item">
              <a :href="web[2].url" target="_blank" :title="web[2].url">{{web[2].text}}</a>
            </div>
          </el-card>
        </el-col>

      </el-row>

    </div>
  </el-main>

</template>

<script>


export default {
  name: 'ImportantLinks',
  data () {
    return {
        links: [
            {'url': 'https://columbus-cdm.formstack.com/forms/rti_1_3', 'text': 'Recepción y Transmisión de Instrucciones'},
            {'url': 'https://columbus-cdm.formstack.com/forms/solicitud_de_traspasos_copy', 'text': 'Solicitud de Traspasos'},
            {'url': 'https://columbus-cdm.formstack.com/forms/solicitud_one_page', 'text': 'Solicitud One Page'},
            {'url': 'https://columbus-cdm.formstack.com/forms/kyc_pf_1_1', 'text': 'Apertura Cta. Individual PF'},
            {'url': 'https://columbus-cdm.formstack.com/forms/kyc_pf_aseguradora', 'text': 'Apertura Aseguradora PF'},
        ],
        tools: [
            {'url': 'http://localhost:8000/validacion', 'text': 'Validación Clientes'},
            {'url': 'Calculadora', 'text': 'Calculadora'},
            {'url': 'https://app.powerbi.com/view?r=eyJrIjoiNDU0NzI2M2EtNmNlOC00MjIyLT' +
                    'gzNmMtMmNkOGNjNDE3NTk5IiwidCI6ImEwNWE0ZDg1LTUxZDgtNDQ4MS1hMDNkLTcyNjI4YjA0NDY2NiJ9', 'text':'Comparativo de Fondos'}
        ],
        openings: [
            {'url': 'https://onboarding.columbus.mx/sign-up', 'text': 'Apertura Aseguradora'},
            {'url': 'https://columbus-cdm.formstack.com/forms/kyc_pm_copy', 'text': 'Apertura Cuenta Individual PM'},
            {'url': 'https://columbus-cdm.formstack.com/forms/kyc_pf_cdp_1_1', 'text':'Apertura Cuenta Individual PF CDP'}
        ],
        complements: [
            {'url': 'https://columbus-cdm.formstack.com/forms/carta_instruccion_v1_2', 'text': 'Carta Instrucción'},
            {'url': 'https://columbus-cdm.formstack.com/forms/posici_n_inicial', 'text': 'Posición Inicial'}
        ],
        reports: [
            {'url': 'https://columbus-cdm.formstack.com/forms/solicitud_one_page', 'text': 'Solicitud One Page'},
            {'url': 'IXION', 'text': 'Análisis Portafolios'}
        ],
        operations: [
            {'url': 'https://columbus-cdm.formstack.com/forms/rti_2_0_weetrust', 'text': 'Recepción y transmisión de instrucciones '},
            {'url': 'https://columbus-cdm.formstack.com/forms/solicitud_de_traspasos_copy', 'text': 'Solicitud Traspasos'}
        ],
        web: [
            {'url': 'https://columbus.mx/', 'text': 'Columbus'},
            {'url': 'https://columbus.mx/login/', 'text': 'Columbus Acceso'},
            {'url': 'https://batial.org/', 'text': 'Batial'}
        ]
    }
  },
  methods :{
      goToLink (link) {
         if (link === '/validacion') {
             this.$router.push(link)
         }
         else if (link === '/calculadora') {
              this.$router.push(link)
          }
         else if (link === '/lista-de-analisis') {
             this.$router.push(link)
         }

      }
  }
};
</script>

<!-- Component styles if required -->
<style scoped>

  .el-main {
    line-height: 10px;
  }

  .top-section {
    margin: 25px 0 38px 50px;
  }

  .list-header {
    margin: 25px 0 38px 0;
  }

  .section-header {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    word-wrap: break-word;
    text-align: start;
  }

  .clearfix:before,
  .clearfix:after {
    display: block;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .card-title{
    font-size: 18px;
    color: rgb(255, 252, 252);
    font-weight: 500;
    margin: 11px;
    height: 40px;
    line-height: 40px;

  }


  .card-row{
    margin: 40px 0 38px 50px;
  }

  .text {
    font-size: 16px;
    font-weight: 500;
    margin: 11px;
    height: 60px;
    line-height: 40px;
  }

  .item {
    margin-bottom: 16px;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-card {
    width: 320px;
    margin-bottom: 20px;

  }

  .box-card /deep/ .el-card__header {
    background-color: #001F5C;
    border-bottom: 2px solid #f56c6c;
  }

  .card-col /deep/ .el-card {
    border-radius: 20px;
    border: 2px solid #001F5C;
  }


</style>




// WEBPACK FOOTER //
// src/components/ImportantLinks.vue